export default __webpack_public_path__ + "static/media/logo_horizontal_admin.04d08a9b.png";